import { Reference } from '@sanity/types';
import imageUrlBuilder from '@sanity/image-url';

import { ChildCategory, ParentCategory } from 'lib/sanity/types';
import { Vertical, getVerticalConfig } from 'utils/vertical';

export const emptyChildCategoriesFilter = (childCategory: ChildCategory): boolean => {
  return childCategory.title !== null && childCategory.articles?.some(article => article.title !== null);
};

export const emptyParentCategoryFilter = (parentCategory: ParentCategory): boolean => {
  if (!parentCategory.title) {
    return false;
  }
  const childCategories = parentCategory.childCategories.filter(emptyChildCategoriesFilter);
  return childCategories.length > 0;
};

export const urlForImage = ({
  source,
  maxWidth,
  vertical,
}: {
  source: Reference;
  maxWidth: number;
  vertical: Vertical;
}): string => {
  return imageUrlBuilder({ clientConfig: getVerticalConfig(vertical).cms })
    .image(source)
    .auto('format')
    .width(maxWidth)
    .fit('max')
    .url();
};

export const srcSetForImage = ({
  source,
  maxWidth,
  vertical,
}: {
  source: Reference;
  maxWidth: number;
  vertical: Vertical;
}): string => {
  return `${urlForImage({ source, maxWidth, vertical })} 1x, ${urlForImage({
    source,
    maxWidth: maxWidth * 2,
    vertical,
  })} 2x`;
};
